import { Controller } from "@hotwired/stimulus";

// 概览里「营收」各格的遮罩开关。
//
// 默认遮起来，点卡片右上角的眼睛才摊开。挡的是「站在旁边的人」这一眼，**不是权限**：
// 真值随首屏 HTML 一起下发（在 data-value 里），看得见源码就看得见数字 —— 要真藏，
// 得改成点开时再去服务端取这个数。
//
// 一实例管**一格**（控制器挂在每张卡自己的容器上，不是整个指标区）：今日与本月各有各的
// 眼睛，点哪一颗只动它那一格。状态只在**当前这一屏**有效 —— 不做持久化，刷新或重新进
// 页面回到遮罩态。「默认遮住」比「上次摊开过就一直摊着」更符合这个按钮存在的理由。
export default class extends Controller {
  static targets = ["value", "button"];

  connect() {
    this.revealed = false;
    this.sync();
  }

  toggle() {
    this.revealed = !this.revealed;
    this.sync();
  }

  // 摊开 / 收起只在这一处落地。名字故意**不带** `#`：前端单测用
  // `Object.create(prototype)` 造实例（见 test/javascript/），而 `#` 私有方法过不了那道
  // brand check（没跑构造函数的对象访问私有方法会抛），测不了 —— 这一步是最该被测的。
  sync() {
    this.valueTargets.forEach((node) => {
      // 遮罩符与真值都由服务端给（`data-mask` / `data-value`），JS 不抄任何字面量。
      node.textContent = this.revealed ? node.dataset.value : node.dataset.mask;
    });

    this.buttonTargets.forEach((button) => {
      // `aria-pressed` 是状态的唯一来源（两颗眼睛的显隐由 CSS 认它，见 application.css）。
      // 文案跟着走：屏幕阅读器听到的必须是**接下来会发生什么**（这里是待摊开 ⇒ 「显示…」），
      // 与图标一致。格子名从按钮自己的 `data-label` 读 —— 两格的眼睛一模一样，光说
      // 「显示营收」分不清点的是哪一格；顺带 JS 里也不必留任何格子名，视图加一格不用改这里。
      const text = `${this.revealed ? "隐藏" : "显示"}${button.dataset.label}`;
      button.setAttribute("aria-pressed", String(this.revealed));
      button.setAttribute("aria-label", text);
      button.title = text;
    });
  }
}
